module.exports = "/img/icon-other.svg?b741b0b8723a29a73a32978f8468e44a";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/icon-other.svg
// module id = 9CG+
// module chunks = 46